<template>
<div class="primarycolor categoryselect">
    <div class="dropdown" v-if="options.length === 1 || typeof options === 'string'">
      <div class="dropdown-selected">
        <span v-if="typeof options === 'string'">
          {{options}}
        </span>
        <span v-else>
          {{options[0].tlabel ? $t(options[0].tlabel) : options[0].name }}
        </span>
      </div>
    </div>
    <Select v-else
      :value="selectedOption"
      value-key="id"
      @change="updateOption"
      placeholder="Select"
      class="select-default select-header"
      :popper-class="popperClass"
      :disabled="disableMenuOptions"
    >
        <Option
          v-for="item in options"
          :key="item.id"
          :label="item.tlabel ? $t(item.tlabel) : (item.label || item.name)"
          :value="item"
        >
        </Option>
    </Select>
  </div>
</template>
<script>
export default {
  data() {
    return {
      selectedOption: {
        name: null,
      },
      showMenu: false,
      placeholderText: 'Please select an item',
    };
  },
  props: {
    options: {
      type: [Array, Object, String],
    },
    selected: {},
    noUpperCase: Boolean,
    disableMenuOptions: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.selectedOption = this.selected;
  },
  computed: {
    popperClass() {
      let commonClass = 'categoryoption';
      return (this.noUpperCase) ? commonClass.concat(" lowerCase") : commonClass;
    },
    // optionList() {
    //   return this.options.filter(val => val.id != this.selectedOption.id);
    // },
  },
  methods: {
    updateOption(option) {
      this.selectedOption = option;
      this.showMenu = false;
      this.$emit('updateOption', this.selectedOption);
    },
  },
};
</script>
<style lang="scss">
.categoryoption{
  &.lowerCase{
    .el-select-dropdown__item{
    text-transform: inherit !important;
  }
  }
}
.primarycolor{
 .dropdown-selected{
    padding:8px 20px;
    height: 44px;
    min-width: 180px;
    line-height: 30px;
 }
}
</style>
